/**
 * Type guard that verifies if a given node is an element node.
 */
export function isElementNode(node: Node): node is Element {
    return node.nodeType === node.ELEMENT_NODE;
}
